import client from './client'
import config from '../const'

export default {
  login: authInfo => {
    return new Promise((resolve, reject) => {
      //   client.post('/auth/login', authInfo)
      console.log('login authinfo', authInfo)
      let params = new URLSearchParams()
      params.append('login_id', authInfo.login_id)
      params.append('login_pass', authInfo.login_pass)
      client
        .post(config.BASE_API_URL + '/manage/login', params)
        .then(res => {
          console.log('auth.js login then', res)
          if (
            typeof res === 'object' &&
            typeof res.data === 'object' &&
            res.data.status == '200'
          ) {
            resolve({
              token: res.data.body.token,
              userId: res.data.body.userId,
              label: res.data.body.label,
              level: res.data.body.level,
              year: res.data.body.year,
              relations: res.data.body.relations,
              limit_timestamp: res.data.body.limit_timestamp
            })
          } else {
            alert('login error')
            reject(new Error('error'))
          }
        })
        .catch(err => {
          console.log('auth.js login erro ', err)
          reject(new Error(err || err.response.message || err.message))
        })
    })
  },
  tokenLogin: authInfo => {
    return new Promise((resolve, reject) => {
      // client.post('/auth/login', authInfo)
      // console.log('authinfo', authInfo);
      let params = new URLSearchParams()
      const headersParam = {
        headers: { [config.BASE_API_HEADER_KEY]: authInfo.token }
      }
      client
        .post(config.BASE_API_URL + '/manage/check', params, headersParam)
        .then(res => {
          console.log('auth.js tokenLogin then', res)
          if (res.data && res.data.body) {
            resolve({
              token: res.data.body.token,
              userId: res.data.body.userId,
              label: res.data.body.label,
              level: res.data.body.level,
              year: res.data.body.year,
              relations: res.data.body.relations,
              limit_timestamp: res.data.body.limit_timestamp
            })
          } else {
            resolve({
              token: '',
              userId: '',
              label: '',
              level: '',
              year: '',
              relations: [],
              limit_timestamp: ''
            })
          }
        })
        .catch(err => {
          console.log('auth.js login erro ', err)
          reject(new Error(err.response.message || err.message))
        })
    })
  },
  // 'regiapi-manage-token'
  logout: token => {
    console.log('logout tokenZ', token)
    return new Promise((resolve, reject) => {
      const header = {
        [config.BASE_API_HEADER_KEY]: token
      }
      console.log('logout tokenA', header, token)
      client
        .get(config.BASE_API_URL + '/manage/logout', { headers: header })
        .then(() => resolve())
        .catch(err => {
          reject(new Error(err.response.data.message || err.message))
        })
    })
  }
}
